import { userService } from '../services/user-service';
import { router } from '../helpers';
import { roleService } from '../services/role-service';

export const authentication = {
    namespaced: true,
    state: {
        userName: null,
        roles: null,
        failedLogin: false,
        telegramUrl: null,
        viberUrl: null,
        showConfirmCodeModal: false,
    },
    actions: {
        async login({ dispatch, commit }, { username, password, signature }) {
            try {
                const authData = await userService.login(username, password, signature);

                if (authData.isSuccess) {
                    if (authData.data.roles.length == 1 && authData.data.roles[0] == roleService.CHECK_EMAIL_CODE) {
                        commit('openConfirmCodeModal');
                    }
                    else {
                        const userSettingsResponse = await userService.getUserSettings();
                        const userSettings = (userSettingsResponse.data) ? userSettingsResponse.data.settings : [];
    
                        commit('loginSuccess', { username: username, roles: authData.data.roles, telegramUrl: authData.data.telegramUrl, viberUrl: authData.data.viberUrl, userSettings: userSettings });
                        router.push('/');
                    }
                }
                else {
                    commit('loginFailure', authData.data);
                    dispatch('alert/error', authData.data, { root: true });
                }
            }
            catch (error) {
                commit('loginFailure', error);
                dispatch('alert/error', error, { root: true });
            }
        },
        async impersonateUser({ dispatch, commit }, { impersonateUser }) {
            try {
                const authData = userService.impersonateUser(impersonateUser);

                if (authData.isSuccess) {
                    const userSettingsResponse = await userService.getUserSettings();
                    const userSettings = (userSettingsResponse.data) ? userSettingsResponse.data.settings : [];

                    commit('loginSuccess', { username: authData.data.userName, roles: authData.data.roles, telegramUrl: authData.data.telegramUrl, viberUrl: authData.data.viberUrl, userSettings: userSettings });
                    router.push('/');
                }
                else {
                    commit('loginFailure', authData.data);
                    dispatch('alert/error', authData.data, { root: true });
                }
            }
            catch (error) {
                commit('loginFailure', error);
                dispatch('alert/error', error, { root: true });
            }
        },
        async logout({ commit }, { impersonateUser }) {
            await userService.logout();
            commit('logout');

            if (!impersonateUser) {
                if (router.currentRoute.path != '/login') {
                    router.push('/login');
                }
            }
        },
        updateUserSettings({ commit }, { userSettings }) {
            commit('updateUserSettings', { userSettings: userSettings });
        },
        async checkEmailCode({ dispatch, commit }, { code }) {
            try {
                const authData = await userService.checkEmailCode(code);

                if (authData.isSuccess) {
                    const userSettingsResponse = await userService.getUserSettings();
                    const userSettings = (userSettingsResponse.data) ? userSettingsResponse.data.settings : [];

                    commit('loginSuccess', { username: authData.data.userName, roles: authData.data.roles, telegramUrl: authData.data.telegramUrl, viberUrl: authData.data.viberUrl, userSettings: userSettings });
                    router.push('/');
                }
                else {
                    commit('loginFailure', authData.data);
                    dispatch('alert/error', authData.data, { root: true });
                }
            }
            catch (error) {
                commit('loginFailure', error);
                dispatch('alert/error', error, { root: true });
            }
        },
    },
    mutations: {
        loginSuccess(state, payload) {
            state.userName = payload.username;
            state.roles = payload.roles;
            state.failedLogin = false;
            state.telegramUrl = payload.telegramUrl;
            state.viberUrl = payload.viberUrl;
            state.userSettings = payload.userSettings;
        },
        loginFailure(state) {
            state.userName = null;
            state.failedLogin = true;
            state.telegramUrl = null;
            state.viberUrl = null;
            state.userSettings = null;
        },
        logout(state) {
            state.userName = null;
            state.telegramUrl = null;
            state.viberUrl = null;
            state.userSettings = null;
        },
        updateUserSettings(state, payload) {
            state.userSettings = payload.userSettings;
        },
        openConfirmCodeModal(state) {
            state.showConfirmCodeModal = true;
        },
        closeConfirmCodeModal(state) {
            state.showConfirmCodeModal = false;
        }
    }
}